<template lang="pug">
div
  app-modal(
    v-if="showModal"
    :closeOutside="false",
    :titulo="isEdit ? 'Edição Sócio' : 'Adicionar Sócio'",
    :width="1000",
    @closeModal="cancelar"
  )
    template(slot="body")
      .modal-body-socio
        validation-observer(ref='observerSocio')
          app-pessoa-socio-retificacao(:pessoa="socio")
          app-documentos-retificacao(
            :maxSize='25',
            :valid-extensions="['pdf','rar', 'zip']",
            :documentos="socio.documentos"
            :tiposDocumentos="documentos"
            :tiposDocumentosObrigatorios="documentosObrigatoriosControle"
            aba="Interessado"
            :observer="$refs.observerSocio"
            @addedDoc="handleDocs",
            @removedDoc="removerDocs"
          )
    template(slot="footer")
      div.buttons
        el-button(
          type="default",
          @click="cancelar"
        ) Cancelar
        el-button(
          type="primary",
          @click="adicionarSocio"
        ) {{ isEdit ? 'Atualizar' : 'Adicionar' }}

  app-divider(label="Listagem de Sócio e Representante Legal")
    template(slot="body")
      .btn-adicionar
        el-button(type='primary', size="small" @click="openModalAdicionar")
          i.fal.fa-plus
          | &nbsp Adicionar
  el-row
    validation-provider(:rules="requireSocioRepresentante()" v-slot="{ errors }", :name="'Interessado/Sócio e Representante Legal'", :value="listSocios")
      .input(:class="{'erro box-error' : errors.length}")
        el-table(
          :data='listSocios'
        )
          div(slot='empty')
            span Não há registros.
          el-table-column(
            prop="pessoa.pessoaFisica.cpf"
            label='CPF'
            align="left",
          )
          el-table-column(
            prop="pessoa.pessoaFisica.nome"
            label='Nome'
          )
          el-table-column(
            :formatter='funcaoSocios'
            label='Função'
          )
          el-table-column(
            label='Ações',
            align="center",
            width="100"
          )
            template(slot-scope='scope')
              el-dropdown(trigger="click", size="small")
                el-button(type='primary', size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot='dropdown')
                  div
                    el-dropdown-item
                      .flex(@click="editarSocio(scope.row)")
                        i.fal.fa-pencil-alt
                        | &nbsp Editar
                  div
                    el-dropdown-item
                      .flex(@click="removeSocio(scope.row)")
                        i.fa.fa-times
                        | &nbsp Remover
      span.help.erro(v-if="errors.length") Deve ser registrado no mínimo um sócio e um representante legal.
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppActionButton from '@/components/AppActionButton'
import AppModal from '@/components/AppModal'
import AppDocumentosRetificacao from './AppDocumentosRetificacao'
import AppPessoaSocioRetificacao from './AppPessoaSocioRetificacao'
import emptyPessoa from '../../cadastros/para/empty/emptyPessoa'
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

const emptySocio = {
  ...emptyPessoa,
  pessoaFisica: {
    ...emptyPessoa.pessoaFisica
  },
  documentos: []
}

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppDivider,
    AppActionButton,
    AppModal,
    AppDocumentosRetificacao,
    AppPessoaSocioRetificacao
  },

  async created () {
    this.orgaoExpedidores = await this.getOrgaosExpedidores()
    this.documentos = await this.findDocumentosByCodigo({codigo: 'SOCIO'})
    this.documentos = this.documentos.filter(item => item.codigo !== 'IDENTIFICACAO_PESSOAL_SOCIO')
    this.documentosObrigatorios = await this.findDocumentosByCodigo({codigo: 'SOCIO'})
    this.documentosObrigatoriosControle = this.documentosObrigatorios
  },

  data () {
    return {
      socio: _.cloneDeep(emptySocio),
      documentos: [],
      documentosObrigatorios: [],
      documentosObrigatoriosControle: [],
      showModal: false,
      isEdit: false,
      documentosAlterados: [],
      documentosSocio: [],
      listDocs: null,
      listSocios: this.socios,
      orgaoExpedidores: []
    }
  },

  props: {
    socios: {
      type: Array,
      required: true
    },

    aba: {
      type: String,
      default: 'Interessado'
    },

    required: {
      type: Boolean,
      default: true
    },

    idProcesso: {
      type: Number,
      required: true
    }
  },

  methods: {
    ...mapActions('retificacao', ['update']),
    ...mapActions({
      findDocumentosByCodigo: 'tipoDocumento/findTiposDocumentoByCodigo',
      saveRelDocumentoProcessoRetificacao: 'relDocumentoProcessoRetificacao/saveRelDocumentoProcessoRetificacao',
      deleteDocumentoById: 'documentos/deleteDocumentoById',
      getOrgaosExpedidores: 'orgaosExpedidores/getItems'
    }),

    requireSocioRepresentante () {
      const hasSocioRepresentante = this.listSocios.some(soc => soc.funcao === 'SOCIO' && soc.isSocioRepresentanteLegal)
      const hasRepresentante = this.listSocios.some(soc => soc.funcao.includes('REPRESENTANTE'))
      const hasSocio = this.listSocios.some(soc => soc.funcao === 'SOCIO')
      if (hasSocioRepresentante || (hasRepresentante && hasSocio)) {
        return ''
      } else {
        return 'required'
      }
    },

    openModalAdicionar () {
      this.socio = _.cloneDeep(emptySocio)
      this.showModal = true
    },

    async adicionarSocio () {
      const valid = await this.$refs.observerSocio.validate()

      if (valid) {
        let socio = _.find(this.listSocios, item => item.pessoa.pessoaFisica.cpf === this.socio.pessoaFisica.cpf)

        if (socio && !this.isEdit) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            'Esse CPF já se encontra na lista de sócios.'
          )

          return
        }

        const newObjectSocio = {
          documentos: this.socio.documentos,
          funcao: this.socio.funcao,
          isSocioRepresentanteLegal: this.socio.isSocioRepresentanteLegal,
          pessoa: {
            isPessoaFisica: true,
            email: this.socio.pessoaFisica.email,
            pessoaFisica: this.socio.pessoaFisica
          }
        }

        if (this.isEdit) {
          const newArray = this.listSocios.filter(soc => soc !== socio)
          this.listSocios = newArray
          this.listSocios.push(newObjectSocio)
          this.isEdit = false
        } else {
          this.socio.id = uuidv4()
          this.listSocios.push(newObjectSocio)
        }

        this.showModal = false
        this.socio = {}
        this.documentosSocio = []
        return
      }

      this.showNotificacao(
        this.$messages.TIPO_WARNING,
        this.$messages.TITULO_WARNING,
        this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
      )
    },

    cancelar () {
      this.showModal = false
      this.isEdit = false
      this.$refs.observerSocio.reset()
    },

    removeSocio (socio) {
      this.confirmBox('Tem certeza que deseja remover?', this.$messages.TITULO_WARNING,
        () => {
          const index = _.findIndex(this.listSocios, item => item.pessoa.pessoaFisica.cpf === socio.pessoa.pessoaFisica.cpf)
          this.listSocios.splice(index, 1)
        },
        () => {
        }, 'Sim', 'Não')
    },

    editarSocio (socio) {
      let newObjectSocio = {}
      if (socio.pessoa.email !== undefined) {
        newObjectSocio = {
          documentos: socio.documentos,
          funcao: socio.funcao,
          isSocioRepresentanteLegal: socio.isSocioRepresentanteLegal,
          pessoaFisica: {
            ...socio.pessoa.pessoaFisica,
            email: socio.pessoa.email,
            orgaoExpedidor: {
              ...socio.pessoa.pessoaFisica.orgaoExpedidor,
              nome: this.orgaoExpedidores.filter(orgao => orgao.codigo === socio.pessoa.pessoaFisica.orgaoExpedidor.codigo)[0].nome
            }
          }
        }
      } else {
        newObjectSocio = {
          documentos: socio.documentos,
          funcao: socio.funcao,
          isSocioRepresentanteLegal: socio.isSocioRepresentanteLegal,
          pessoaFisica: {
            ...socio.pessoa.pessoaFisica,
            orgaoExpedidor: {
              ...socio.pessoa.pessoaFisica.orgaoExpedidor,
              nome: this.orgaoExpedidores.filter(orgao => orgao.codigo === socio.pessoa.pessoaFisica.orgaoExpedidor.codigo)[0].nome
            }
          }
        }
      }
      this.isEdit = true
      this.socio = newObjectSocio
      this.showModal = true
    },

    async handleDocs (dados) {
      const doc = {
        id: null,
        _id: dados.id,
        key: dados.fileKey,
        hash: null,
        nome: dados.fileName,
        tipo: dados.tipoDocumento,
        base64: null,
        caminho: null
      }
      this.documentosAlterados.push(doc)
      const newDoc = await this.createDocByKey(doc)
      this.documentosSocio.push(newDoc)
      this.listDocs = [...this.documentosSocio]
      this.socio.documentos = this.listDocs
      const payload = {
        idDocumento: newDoc.id,
        idProcesso: this.idProcesso
      }
      await this.saveRelDocumentoProcessoRetificacao(payload)
    },

    async removerDocs (doc) {
      if (doc.id) {
        this.documentosAlterados = this.documentosAlterados.filter(item => item.id !== doc.id)
      } else {
        this.documentosAlterados = this.documentosAlterados.filter(item => item.caminho !== doc.fileKey)
      }
      this.listDocs = [...this.socio.documentos.filter(documento => doc.id !== documento.id)]
      this.socio.documentos = this.listDocs
      this.documentosSocio = this.listDocs
      if (doc?.id) {
        await this.deleteDocumentoById(doc.id)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.fileName)
    },
    async createDocByKey (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/createByKey`,
        data: documento
      })
      return file
    },
    funcaoSocios (val) {
      if (val.funcao === 'SOCIO' && !val.isSocioRepresentanteLegal) {
        return 'Sócio'
      } else if (val.funcao === 'SOCIO' && val.isSocioRepresentanteLegal) {
        return 'Sócio/Representante Legal'
      } else {
        return 'Representante Legal'
      }
    }
  },
  watch: {

    'listSocios' (val) {
      this.update({field: 'interessado.sociosRepresentantesLegais', value: val})
    }
  }

}
</script>

<style lang="scss" scoped>
.btn-adicionar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.modal-body-socio {
  padding: 0 20px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppSocioRetificacao.vue